import { SendTestAicaDigestMutation, SendTestAicaDigestMutationVariables } from 'types/graphql'

import { useMutation } from 'src/utils/queryClient'

const SendTestAicaDigestMutationDocument = gql`
  mutation SendTestAicaDigestMutation($input: SendTestAicaDigestInput!) {
    sendTestAicaDigest(input: $input)
  }
`

export const useSendTestAicaDigestMutation = () => {
  return useMutation<SendTestAicaDigestMutation, SendTestAicaDigestMutationVariables>({
    mutationDocument: SendTestAicaDigestMutationDocument,
  })
}
